import React from "react";
import { DateTime } from 'luxon/build/node/luxon';;
import * as classes from './footer.module.css'
// import classes from './footer.module.css'
export default function Footer() {
  let year = DateTime.now().toObject().year;
  return (
    <footer className={classes.footer}>
      <h4>
        <span>©</span> Copyright Realtimeknowledge.com Ltd {year}
      </h4>
    </footer>
  );
}
